import { useFormContext, useWatch } from 'react-hook-form'

import { ControlledDatePicker, ControlledSelector } from 'components/common/controller-wrapper'
import {
  SUPPLIER_ACTIVATION_EARLIEST_DATE,
  SUPPLIER_ACTIVATION_PERIOD_LABEL,
  SUPPLIER_ACTIVATION_PERIODS,
} from 'components/reports/Metrics/constants/SupplierActivation'

import { VEHICLE_TYPES } from '../constants/vehicleTypes'
import { SupplierActivationFilterValues } from './SupplierActivationFilterCriteria'

export const SupplierActivationFiltersForm = () => {
  const { control } = useFormContext<SupplierActivationFilterValues>()
  const period = useWatch({ control, name: 'period' })
  const customStart = useWatch({ control, name: 'customStart' })
  const customEnd = useWatch({ control, name: 'customEnd' })
  const isCustom = period === 'custom'

  return (
    <>
      <ControlledSelector
        control={control}
        name='period'
        label={SUPPLIER_ACTIVATION_PERIOD_LABEL}
        options={SUPPLIER_ACTIVATION_PERIODS}
        size='small'
        fullWidth={false}
        sx={{ minWidth: 260, flexGrow: { xs: 1, sm: 0 } }}
      />

      {isCustom && (
        <>
          <ControlledDatePicker
            control={control}
            name='customStart'
            label='From'
            minDate={SUPPLIER_ACTIVATION_EARLIEST_DATE}
            maxDate={customEnd ?? new Date()}
            size='small'
            fullWidth={false}
            sx={{ minWidth: 150 }}
          />
          <ControlledDatePicker
            control={control}
            name='customEnd'
            label='To'
            minDate={customStart ?? SUPPLIER_ACTIVATION_EARLIEST_DATE}
            maxDate={new Date()}
            size='small'
            fullWidth={false}
            sx={{ minWidth: 150 }}
          />
        </>
      )}

      <ControlledSelector
        control={control}
        name='vehicleType'
        label='Vehicle type'
        options={VEHICLE_TYPES}
        size='small'
        fullWidth={false}
        sx={{ minWidth: 170, flexGrow: { xs: 1, sm: 0 } }}
      />
    </>
  )
}
